export interface ProcurementPlanItem {
  id: string
  item: string
  category: string
  estimatedValue: string
  procurementMethod: string
  quarter: string
  status: 'planned' | 'in-progress' | 'completed'
}

export interface ContractAward {
  id: string
  contractRef: string
  title: string
  awardedTo: string
  value: string
  awardDate: string
  duration: string
}

export interface UnsuccessfulBidNotification {
  id: string
  reference: string
  title: string
  date: string
  documentUrl: string
}

export interface ProcurementDocument {
  id: string
  title: string
  description: string
  category: string
  version: string
  date: string
  documentUrl: string
  featured?: boolean
}

export const procurementPlan: ProcurementPlanItem[] = [
  {
    id: '1',
    item: 'Medical Equipment Supply',
    category: 'Health',
    estimatedValue: '£2,500,000',
    procurementMethod: 'International Competitive Bidding',
    quarter: 'Q2 2026',
    status: 'in-progress',
  },
  {
    id: '2',
    item: 'Trade Facilitation Centre Construction',
    category: 'Infrastructure',
    estimatedValue: '£8,750,000',
    procurementMethod: 'International Competitive Bidding',
    quarter: 'Q2 2026',
    status: 'in-progress',
  },
  {
    id: '3',
    item: 'Digital Skills Training Services',
    category: 'Education',
    estimatedValue: '£1,200,000',
    procurementMethod: 'Request for Proposals',
    quarter: 'Q2 2026',
    status: 'in-progress',
  },
  {
    id: '4',
    item: 'Climate Finance Advisory',
    category: 'Consulting',
    estimatedValue: '£650,000',
    procurementMethod: 'Request for Proposals',
    quarter: 'Q2 2026',
    status: 'in-progress',
  },
  {
    id: '5',
    item: 'Agricultural Technology Package',
    category: 'Agriculture',
    estimatedValue: '£3,200,000',
    procurementMethod: 'International Competitive Bidding',
    quarter: 'Q3 2026',
    status: 'planned',
  },
  {
    id: '6',
    item: 'IT Infrastructure Upgrade',
    category: 'Technology',
    estimatedValue: '£1,800,000',
    procurementMethod: 'Restricted Tendering',
    quarter: 'Q3 2026',
    status: 'planned',
  },
]

export const contractAwards: ContractAward[] = [
  {
    id: '1',
    contractRef: 'AU-AFRI-2025-089',
    title: 'Renewable Energy Infrastructure Assessment',
    awardedTo: 'Green Energy Consultants Ltd',
    value: '£450,000',
    awardDate: '2026-03-15',
    duration: '6 months',
  },
  {
    id: '2',
    contractRef: 'AU-AFRI-2025-092',
    title: 'Transport Corridor Feasibility Study',
    awardedTo: 'African Infrastructure Partners',
    value: '£720,000',
    awardDate: '2026-02-28',
    duration: '8 months',
  },
  {
    id: '3',
    contractRef: 'AU-AFRI-2025-078',
    title: 'Health Systems Capacity Assessment',
    awardedTo: 'Global Health Solutions',
    value: '£380,000',
    awardDate: '2026-01-20',
    duration: '4 months',
  },
  {
    id: '4',
    contractRef: 'AU-AFRI-2025-065',
    title: 'Trade Policy Research Services',
    awardedTo: 'Economic Research Institute',
    value: '£290,000',
    awardDate: '2025-12-10',
    duration: '12 months',
  },
  {
    id: '5',
    contractRef: 'AU-AFRI-2025-071',
    title: 'Digital Platform Development',
    awardedTo: 'TechBridge Solutions',
    value: '£950,000',
    awardDate: '2026-01-05',
    duration: '10 months',
  },
  {
    id: '6',
    contractRef: 'AU-AFRI-2025-083',
    title: 'Agricultural Training Programme Delivery',
    awardedTo: 'AgriSkills International',
    value: '£620,000',
    awardDate: '2026-02-15',
    duration: '18 months',
  },
]

export const unsuccessfulBids: UnsuccessfulBidNotification[] = [
  {
    id: '1',
    reference: 'AU-AFRI-2025-089',
    title:
      'Notification of Unsuccessful Bids - Renewable Energy Infrastructure Assessment',
    date: '2026-03-15',
    documentUrl: '#',
  },
  {
    id: '2',
    reference: 'AU-AFRI-2025-092',
    title:
      'Notification of Unsuccessful Bids - Transport Corridor Feasibility Study',
    date: '2026-02-28',
    documentUrl: '#',
  },
  {
    id: '3',
    reference: 'AU-AFRI-2025-078',
    title:
      'Notification of Unsuccessful Bids - Health Systems Capacity Assessment',
    date: '2026-01-20',
    documentUrl: '#',
  },
  {
    id: '4',
    reference: 'AU-AFRI-2025-065',
    title: 'Notification of Unsuccessful Bids - Trade Policy Research Services',
    date: '2025-12-10',
    documentUrl: '#',
  },
  {
    id: '5',
    reference: 'AU-AFRI-2025-071',
    title: 'Notification of Unsuccessful Bids - Digital Platform Development',
    date: '2026-01-05',
    documentUrl: '#',
  },
]

const AU_PROCUREMENT_PDF_URL =
  'https://raw.githubusercontent.com/22fedss-jpg/manualprocurement/main/Procurement_Manual.pdf'

export const procurementDocuments: ProcurementDocument[] = [
  {
    id: '1',
    title: 'African Union Procurement Manual 2026',
    description:
      'Comprehensive guide to AU procurement policies, procedures, and best practices. Covers the full procurement cycle from planning to contract management.',
    category: 'Manual',
    version: '2.0',
    date: '2026-01-01',
    documentUrl: AU_PROCUREMENT_PDF_URL,
    featured: true,
  },
  {
    id: '2',
    title: 'Supplier Code of Conduct',
    description:
      'Ethical standards and conduct requirements for all AU suppliers and contractors.',
    category: 'Guidelines',
    version: '2.0',
    date: '2026-02-18',
    documentUrl: AU_PROCUREMENT_PDF_URL,
  },
  {
    id: '3',
    title: 'Procurement Ethics and Integrity Framework',
    description:
      'Framework for maintaining transparency, accountability, and ethical conduct in all procurement activities.',
    category: 'Guidelines',
    version: '2.0',
    date: '2026-01-22',
    documentUrl: AU_PROCUREMENT_PDF_URL,
  },
  {
    id: '4',
    title: 'Supplier Registration Handbook',
    description:
      'Step-by-step guide for suppliers wishing to register with the African Union.',
    category: 'Handbook',
    version: '2.0',
    date: '2026-02-05',
    documentUrl: AU_PROCUREMENT_PDF_URL,
  },
]
